require('./modules/accordion');
require('./modules/animatein');
require('./modules/formInputs');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/tooltip');
require('./plugins/experian/contact-data-services.min');
require('./plugins/pickajquery.js');
require('./plugins/equalise.js');

import '../../SMP/js/repeater'



// WEBPACK FOOTER //
// ./packages/OSB/js/package.js